"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[36206],{

/***/ 36206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomeWarrantyBenefits; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const benefits = [
    {
        title: "Save Money",
        content: "A home warranty can save money by covering the cost of repairs or replacements, providing discounts on regular maintenance services, and offering coverage for pre-existing conditions. With a home warranty, homeowners can avoid paying these high costs and pay a lower service fee."
    },
    {
        title: "Save Time",
        content: "Home warranties save homeowners time by streamlining repairs and replacements. With a warranty, homeowners can easily submit a claim and have a technician dispatched promptly, eliminating the need for time-consuming searches and scheduling."
    },
    {
        title: "Bonus Benefits ",
        content: "Some home warranty companies offer additional benefits to sweeten the deal. Homeowners may be eligible for exclusive discounts on home security products, restaurants, or popular products. However, these benefits vary based on the home warranty company and chosen plan."
    }, 
];
function HomeWarrantyBenefits() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-24 gap-12 lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[250px] h-[350px] lg:w-[449px] lg:min-w-[449px] lg:h-[674px] relative mx-auto lg:mx-0 order-2 lg:order-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/homewarranty.center/assets/images/homeWarrantyBenefitsImg.png",
                    alt: "Image",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-[638px] mx-auto lg:mx-0 order-1 lg:order-2",
                children: benefits.map((point, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " mt-14 first-of-type:mt-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex gap-3 items-end",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block w-[6px] h-[42px] bg-[#F6CEBE]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "font-bold lg:text-2xl text-lg ",
                                        children: point.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-5 font-light lg:text-lg text-base lg:leading-8 text-[#505050]",
                                children: point.content
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ })

}]);